import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbInputModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaInput } from './../../../models';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-texarea-input',
	template: `
		<textarea
			[attr.id]="controlId"
			nbInput
			fullWidth
			fieldSize="medium"
			[rows]="control.rows"
			[status]="control.colorStatus"
			[placeholder]="control.placeholder | translate"
			[formControl]="control"
		></textarea>
	`,
	standalone: true,
	imports: [NbInputModule, ReactiveFormsModule, TranslateModule]
})
export class TextareaInputComponent extends BaseInputComponent {
	@Input({ required: true }) control: TextareaInput;
}
